import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CassAccountsPgComponent } from './cass-accounts-pg/cass-accounts-pg.component';

const routes: Routes = [
  {
    path: '',
    component: CassAccountsPgComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CassAccountsPageRoutingModule { }
